import { useTrialBanner } from "@/react/components/Layout/TrialBanner/useTrialBanner";
import { useTrialBannerVariant } from "@/react/hooks/experiments/useTrialBannerVariant";
import { PlansModalButton } from "./PlansModalButton";
import { VariantA } from "./VariantA";
import { VariantB } from "./VariantB";

export const TrialOffer = () => {
  const { isCommunityOnTrial } = useTrialBanner();
  const { isVariantA, isVariantB } = useTrialBannerVariant();

  if (!isCommunityOnTrial) {
    return null;
  }

  if (isVariantA) {
    return <VariantA />;
  }
  if (isVariantB) {
    return <VariantB />;
  }

  return <PlansModalButton />;
};
